import { useState } from 'react';
import styles from './TextDropbox.module.css';
import icon from '../../assets/dropboxFAQ-icon.svg';

export const TextDropbox = ({ title, children }) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<div className={styles.main}>
			<div
				onClick={() => setIsOpen(!isOpen)}
				className={styles.titleBlock}
				style={isOpen ? { marginBottom: 3 } : {}}
			>
				<span>{title}</span>
				<img
					src={icon}
					alt="icon"
					className={isOpen ? styles.rotate : ''}
				/>
			</div>

			<div className={`${styles.text} ${isOpen ? styles.textOpen : ''}`}>
				{children}
			</div>
		</div>
	);
};
